import { UserOutlined, WechatOutlined, MenuOutlined } from '@ant-design/icons';
import { Avatar, Badge, Image, Space, Dropdown, Menu } from 'antd';
import React from 'react'
import { Link } from 'react-router-dom';
import SignOutButton from './SignOutButton';

function Header({ user }) {
    const menu = (
        <Menu>
            <Menu.Item key="1">
                <Link to="/">Response Evaluations Manager</Link>
            </Menu.Item>
            <Menu.Item key="2">
                <Link to="/ResponseAnalyticsDashboard">Response Analytics Dashboard</Link>
            </Menu.Item>
        </Menu>
    );

    return (
        <div className="topbar">
            <div className="topbarWrapper">
                <div className="topLeft" style={{ display: 'flex', alignItems: 'center' }}>
                    <Dropdown overlay={menu} trigger={['click']}>
                        <div className="hamburgerMenu" style={{ display: 'inline-block', marginRight: '10px', cursor: 'pointer' }}>
                            <MenuOutlined style={{ fontSize: '36px', color: '#fff' }} />
                        </div>
                    </Dropdown>
                    <div className="logo" style={{ display: 'inline-block' }}>
                        <span style={{ color: 'rgb(255, 255, 255)', display: 'block' }}>GenAI Knowledge Finder</span>
                        <span style={{ color: 'rgb(255, 255, 255)', fontSize: '12px', float: 'right' }}>Admin Portal</span>
                    </div>
                </div>
                <div className="topRight">

                    {/* <div className="topbarIconContainer">
                        <i className="bx bx-message" style={{ fontSize: '1.2em', marginRight: 5 }} />
                        <Link to="/"><span>Chat</span></Link>
                    </div> */}

                    <div className="topbarIconContainer">
                        <i className="bx bx-support" style={{ fontSize: '1.2em', marginRight: 5 }} />
                        <Link to="mailto:manohar.reddyuppula@dupont.com; harish.nareddy@dupont.com; raymond.m.osterman@dupont.com?subject=GenAI Knowledge Finder Admin Portal Support&body="><span>Support</span></Link>
                    </div>

                    <div className="topbarIconContainer">
                        <i className="bx bx-bulb" style={{ fontSize: '1.5rem' }} />
                        <Link target="_blank" to="https://dupont.sharepoint.com/sites/ITMatters/SitePages/Generative-AI-at-DuPont.aspx"><span>Learn more & submit ideas</span></Link>
                    </div>

                    <div className="topbarIconContainer">
                        <Space>
                            {user.avatar === null ?
                                <Avatar
                                    style={{ backgroundColor: "#fde3cf", color: "#f56a00", borderColor: "#E1E1E1" }}
                                    src={null}
                                >
                                    <span style={{ fontWeight: 700, fontSize: 12 }}>{user.firstname[0]}{user.lastname[0]}</span>
                                </Avatar>

                                : <Avatar
                                    // shape="square"
                                    style={{ borderColor: "#E1E1E1" }}
                                    src={user.avatar}
                                />
                            }

                            <span>{user.fullname}</span>
                        </Space>
                    </div>

                    {/* <img src="https://www.dupont.com/content/dam/dupont/global-assets/logos/DuPont_logo_140x55_rgb1.png" className="topAvatar" /> */}


                    <div className="topbarIconContainer">
                        <SignOutButton />
                    </div>

                    <div className="topbarIconContainer">
                        <Image
                            height={24}
                            src='../assets/DuPont_tm_w.svg'
                            preview={false}
                        />
                    </div>

                </div>
            </div>
        </div >
    );
}

export default Header